export const theme = {
  colors: {
    // Primary colors - Gaming style
    primary: '#5aeaa5',      // Teal green (from Shopify)
    primaryDark: '#3ac785',
    primaryLight: '#7fffc5',

    // Background colors - Dark gaming theme
    background: {
      primary: '#0a0e27',    // Very dark blue (gaming)
      secondary: '#121212',   // Pure dark
      tertiary: '#1a1e35',    // Slightly lighter dark blue
      card: '#1e2337',        // Card background
      overlay: '#242833',     // Overlay color (from Shopify)
    },

    // Text colors
    text: {
      primary: '#ffffff',
      secondary: '#b8b8b8',
      accent: '#5aeaa5',
      disabled: '#666666',
    },

    // Border colors
    border: {
      primary: 'rgba(90, 234, 165, 0.3)',
      secondary: 'rgba(255, 255, 255, 0.1)',
    },

    // Status colors
    success: '#4caf50',
    warning: '#ff9800',
    error: '#f44336',
    info: '#2196f3',

    // Gaming accents
    neon: {
      cyan: '#00f0ff',
      pink: '#ff006e',
      purple: '#9b59b6',
      yellow: '#ffde59',
    },
  },

  // Typography
  fonts: {
    primary: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    heading: "'Orbitron', 'Poppins', sans-serif",
    mono: "'Fira Code', 'Courier New', monospace",
  },

  fontSizes: {
    xsmall: '0.75rem',    // 12px
    small: '0.875rem',    // 14px
    medium: '1rem',       // 16px
    large: '1.125rem',    // 18px
    xlarge: '1.25rem',    // 20px
    xxlarge: '1.5rem',    // 24px
    hero: '3rem',         // 48px
    mega: '4rem',         // 64px
  },

  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  // Spacing
  spacing: {
    xsmall: '0.25rem',    // 4px
    small: '0.5rem',      // 8px
    medium: '1rem',       // 16px
    large: '1.5rem',      // 24px
    xlarge: '2rem',       // 32px
    xxlarge: '3rem',      // 48px
    mega: '4rem',         // 64px
  },

  // Border radius
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    xlarge: '16px',
    round: '50%',
  },

  // Shadows - Gaming glow effects
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.3)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.4)',
    large: '0 8px 16px rgba(0, 0, 0, 0.5)',
    glow: '0 0 20px rgba(90, 234, 165, 0.5)',
    glowStrong: '0 0 30px rgba(90, 234, 165, 0.8)',
    neon: '0 0 10px rgba(0, 240, 255, 0.6), 0 0 20px rgba(0, 240, 255, 0.4)',
  },

  // Transitions
  transitions: {
    fast: '150ms ease-in-out',
    medium: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },

  // Breakpoints
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1400px',
  },

  // Z-index layers
  zIndex: {
    base: 1,
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
};

export type Theme = typeof theme;
